import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { finalize, tap } from 'rxjs/operators';
import { EntraIdGroupMember, EntraIdGroupMemberResponse } from '../../interfaces/admin/EntraIdGroupMember';
import { GraphService } from '../../../auth/services/graph.service';
import { DeleteWorkflow, LoadAllEntraIdGroupMembers } from './admin.actions';
import { Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { WorkflowDataService } from '../../services/workflow-data.service';

export interface AdminStateModel {
    entraIdGroupMembers: EntraIdGroupMember[];
    isLoading: boolean;
}

@State<AdminStateModel>({
    name: 'admin',
    defaults: {
        entraIdGroupMembers: [],
        isLoading: false
    }
})
@Injectable()
export class AdminState {
    private graphService = inject(GraphService);
    private workflowService = inject(WorkflowDataService);

    @Selector()
    static entraIdGroupMembers(state: AdminStateModel): EntraIdGroupMember[] {
        return state.entraIdGroupMembers;
    }

    @Selector()
    static isLoading(state: AdminStateModel): boolean {
        return state.isLoading;
    }

    @Action(LoadAllEntraIdGroupMembers)
    fetchCards(
        ctx: StateContext<AdminStateModel>,
        { groupId }: LoadAllEntraIdGroupMembers
    ): Observable<EntraIdGroupMemberResponse | HttpErrorResponse> {
        this.setIsLoading(ctx, true);
        return this.graphService.getGroupMembers(groupId).pipe(
            tap((entraIdGroupMembers: EntraIdGroupMemberResponse) =>
                ctx.patchState({ entraIdGroupMembers: entraIdGroupMembers.value })
            ),
            finalize(() => this.setIsLoading(ctx, false))
        );
    }

    @Action(DeleteWorkflow)
    deleteWorkflow(_ctx: StateContext<AdminStateModel>, action: DeleteWorkflow): Observable<void | HttpErrorResponse> {
        return this.workflowService.deleteWorkflow(action.workflowId);
    }

    private setIsLoading(ctx: StateContext<AdminStateModel>, isLoading: boolean): void {
        ctx.patchState({ isLoading });
    }
}
